import { render, staticRenderFns } from "./newPos.vue?vue&type=template&id=39e611fe"
import script from "./newPos.vue?vue&type=script&lang=js"
export * from "./newPos.vue?vue&type=script&lang=js"
import style0 from "./newPos.vue?vue&type=style&index=0&id=39e611fe&prod&lang=css&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports